import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Egate } from "./Landing_PAGE/Egate";
import LoadingSpinner from './LoadingSpinner.jsx'
import CardsAhaguru from "./AhaGuru_CardDesigns/CardsAhaguru.jsx";

import { GenerateAndUploadLogins } from "./Admin/GenerateAndUploadLogins.jsx";
import PgMainHomePage from "./PG_StaticHomePage/PgMainHomePage.jsx";
import process from 'process';
window.process = process;

const JsonFetchingFromBlob = React.lazy(() =>
  import("./Blob/JsonFetchingFromBlob.jsx")
);
const PGExamsHomePage = React.lazy(() =>
  import("./PG_StaticHomePage/PGExamsHomePage.jsx")
);
const OnlineRecordedLecturesHomePage = React.lazy(() =>
  import(
    "./ExamHomePage/OnlineRecordedLecturesHomePages/OnlineRecordedLecturesHomePage.jsx"
  )
);
const BitsatCourse = React.lazy(() =>
  import("./ExamHomePage/Bitsatcourse.jsx")
);
const Pg_home_page = React.lazy(() =>
  import("./components/PG/PG_homePage/Pg_home_page").then((module) => ({
    default: module.Pg_home_page,
  }))
);
const State = React.lazy(() =>
  import("./components/PG/context/State.jsx").then((module) => ({
    default: module.State,
  }))
);
const ScrollToTop = React.lazy(() => import("./Landing_PAGE/ScrollToTop.js"));


const Pricing_Policy = React.lazy(() =>
  import("./components/UG/Pricing_Policy.jsx")
);
const TERMsCONDITIONS = React.lazy(() =>
  import("./components/UG/TERMsCONDITIONS").then((module) => ({
    default: module.TERMsCONDITIONS,
  }))
);
const Privacypolicy = React.lazy(() =>
  import("./components/UG/Privacypolicy").then((module) => ({
    default: module.Privacypolicy,
  }))
);
const CancellationRefundPolicy = React.lazy(() =>
  import("./components/UG/CancellationRefundPolicy.jsx")
);

const OurOfferingsPage = React.lazy(() =>
  import("./Landing_PAGE/OurOfferingsPage.jsx")
);
const Careers_file = React.lazy(() =>
  import("./Landing_PAGE/Careers_file.jsx")
);

const App = () => {


  return (

    <State>
      <Router future={{ v7_startTransition: true }}>
        <ScrollToTop />
        <Routes>
          <Route path='/admin' element={<GenerateAndUploadLogins/>}/>
          {/* This is a link for landing page */}
          {/* <Route path="/" element={<Egate />} /> */}
          <Route
            path="/OurOfferingsPage"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <OurOfferingsPage />
              </Suspense>
            }
          />
          <Route
            path="/Careers_file"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <Careers_file />
              </Suspense>
            }
          />

          <Route
            path="/Exams/:ExamHomePage"
            element={
              <Suspense fallback={<LoadingSpinner />}>
             <PGExamsHomePage />
              </Suspense>
            }
          />
            <Route
            path="/"
            element={
              <Suspense fallback={<LoadingSpinner />}>
               <PgMainHomePage />
              </Suspense>
            }
          />
          <Route
            path="/OnlineRecordedLecturesHomePage/:examId"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <OnlineRecordedLecturesHomePage />
              </Suspense>
            }
          />
          <Route
            path="/Bitsatcourse"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <BitsatCourse />
              </Suspense>
            }
          />

          <Route
            path="/PGHome"
            element={
              <Suspense fallback={<div>Loading ...</div>}>
                <Pg_home_page />
              </Suspense>
            }
          />
          {/* *********************************FOOTER FILES********************* */}
          <Route
            path="/terms"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <TERMsCONDITIONS />
              </Suspense>
            }
          />
          <Route
            path="/CancellationRefundPolicy"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <CancellationRefundPolicy />
              </Suspense>
            }
          />
          <Route
            path="/policy"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                {" "}
                <Privacypolicy />
              </Suspense>
            }
          />
          <Route
            path="/pricingpolicy"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <Pricing_Policy />{" "}
              </Suspense>
            }
          />
          {/* *****************************FOOTER FILES END*************************  */}

          <Route
            path="/blob"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <JsonFetchingFromBlob />
              </Suspense>
            }
          />

          <Route path="/cssCards" element={<CardsAhaguru/>}/>
        </Routes>

      </Router>
    </State>
  );
};


export default App;